const getCityName = (globals) => {
  // return 'sarov'

  const { host } = globals

  if (/^(zv|smart-fe26|smart-fe\.fe26)/.test(host)) {
    return 'zv'
  }
  if (/snz\.rosatom.city/.test(host)) {
    return 'snz'
  }
  if (/smartkyzyl/.test(host)) {
    return 'kyzyl'
  }
  if (/kurchatov\.rosatom\.city/.test(host)) {
    return 'kurchatov'
  }

  if (window && window.location && window.location.search) {
    const query = window.location.search.replace(/^\?/, '').split('&').reduce((result, pair) => {
      const [ key, value ] = pair.split('=')
      result[key] = value

      return result
    }, {})

    if (query.city) {
      return query.city
    }
  }

  return 'sarov'
  // return 'zv'
  // return 'kurchatov'
}


export default getCityName
